import { LinearProgress } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";
import { useSession } from "src/context/SessionProvider";
import ClinicianProvider from "src/context/SessionProvider/ClinicianProvider";
import KnowledgeAssistant from "../KnowledgeAssistant";

const ProtectedRoute = () => {
  const { session, loading } = useSession();

  if (loading) {
    return <LinearProgress />;
  }

  if (!session) {
    return <Navigate to={`/login`} replace />;
  }

  return (
    <ClinicianProvider>
      <Outlet />
      <KnowledgeAssistant />
    </ClinicianProvider>
  );
};

export default ProtectedRoute;
